import { ReduceStore } from "flux/utils";
import Dispatcher from "Dispatcher";
import DataDefActions from "./DataDefActions";
import { hotLoadObject } from "data/storeUtils";
import dotProp from "dot-prop-immutable";
import LoadObject from "data/LoadObject";
import DataManager from "data/DataManager";
import userStore from "data/userStore";
import invariant from "invariant";
import { FIRST_FIELD } from "data/ActiveFormStore";

const keyPath = (entityKey, fieldKey) => {
    if (typeof entityKey !== "string") {
        // assume it's an action
        const a = entityKey;
        entityKey = a.entityKey;
        fieldKey = a.fieldKey;
    }
    return `${entityKey}.${fieldKey}`;
};

/*
 * Once we get to `model.json` (or whatever), this will become obsolete-ish...
 */
class DataDefStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return {};
    }

    reduce(state, action) {
        switch (action.type) {
            case DataDefActions.START_LOAD:
                this.__dispatcher.waitFor([
                    userStore.getDispatchToken(),
                ]);
                // todo: withPropTypes!
                return dotProp.set(state, [keyPath(action)], LoadObject.empty().loading(
                    DataManager.loadDataDefinition(
                        action.entityKey,
                        action.fieldKey,
                        userStore.getActiveOrgKey()
                    )
                ));
            case DataDefActions.LOADED:
                return dotProp.set(state, [keyPath(action)], lo => lo.receiveValue(action.data));
            case DataDefActions.LOAD_ERROR:
                return dotProp.set(state, [keyPath(action)], lo => lo.receiveError(action.error));
            default:
                return state;
        }
    }

    getDefinitions(entityKey, fieldKey) {
        return this.getDefinitionsLO(entityKey, fieldKey).getRequiredValue();
    }

    getDefinitionsLO(entityKey, fieldKey) {
        invariant(
            entityKey && fieldKey && fieldKey !== FIRST_FIELD,
            `C'mon, field '${entityKey}.${fieldKey}'? Really?`
        );
        return hotLoadObject(
            () => this.getState()[keyPath(entityKey, fieldKey)],
            () => Dispatcher.dispatch({
                type: DataDefActions.START_LOAD,
                entityKey,
                fieldKey,
            }),
        );
    }
}

export default new DataDefStore();



// WEBPACK FOOTER //
// ./app/data/meta/DataDefStore.js